import {SpinnerHelper, SpinnerArgs} from "./spinner-helper";

export interface IResponse {
    requestError: boolean;
    error?: any;
    code?: number;
    headers?: Headers;
}

export interface IResponseWithData<T> extends IResponse {
    data?: T;
}

export class RequestHelper {

	public static async postJsonAndSpin<TResponse>(url: string, data: any, includeCredentials = false, spinnerArgs?: SpinnerArgs) {
		return await SpinnerHelper.spinAndDeactivateWhile(RequestHelper.postJson(url, data, includeCredentials), spinnerArgs);
	}

	public static async postJson<TResponse>(url: string, data: any, includeCredentials = false): Promise<IResponseWithData<TResponse>> {
		var init: RequestInit = {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json"
			},
			credentials: includeCredentials ? "include" : "omit",
			body: JSON.stringify(data)
		};

		try {
			const response = await fetch(url, init);
			return {
				requestError: false,
				code: response.status,
				data: await response.json(),
				headers: response.headers
			}
		} catch (exception) {
			return {
				requestError: true,
				error: exception
			}
		}
	}

    public static async getJsonAndSpin<TResponse>(url: string, includeCredentials = false, spinnerArgs?: SpinnerArgs) {
        return await SpinnerHelper.spinAndDeactivateWhile(RequestHelper.getJson(url, includeCredentials), spinnerArgs);
    }

    public static async getJson<TResponse>(url: string, includeCredentials = false): Promise<IResponseWithData<TResponse>> {
        const init: RequestInit = {
            method: "GET",
            credentials: includeCredentials ? "include" : "omit"
        };

        try {
            const response = await fetch(url, init);
            return {
                requestError: false,
                code: response.status,
                data: await response.json(),
                headers: response.headers
            }
        } catch (exception) {
            return {
                requestError: true,
                error: exception
            }
        }
    }
}